import { Color, Text } from '@billy/design-system'
import { differenceInDays } from 'date-fns'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { formatDate } from '../../../../../../utils'
import * as Styled from './styles'

export interface ActivateAlertProps {
  trialEndDate: string
}

export const ActivateAlertComponent = ({ trialEndDate }: ActivateAlertProps) => {
  const { t } = useTranslation()
  const daysOfTrial = differenceInDays(new Date(trialEndDate), new Date()) + 1
  return (
    <Styled.ActivateAlertWrapper>
      <Styled.TitleWrapper>
        <Text variant="h4">{`${t('organization_subscription.plus')} - `}</Text>&nbsp;
        <Text variant="h4" color={Color.Yellow500}>
          {t('organization_subscription.days_of_free_trial_left', { days: daysOfTrial })}
        </Text>
      </Styled.TitleWrapper>

      <Text variant="bodySM" colorVariant="secondary">
        {t('organization_subscription.trial_info', {
          date: formatDate(trialEndDate, 'MMM. dd yyyy'),
        })}
      </Text>
    </Styled.ActivateAlertWrapper>
  )
}
